import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_DosePrice = _resolveComponent("DosePrice")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar, { "app-webview": _ctx.appWebview }, null, 8, ["app-webview"]),
    _createVNode(_component_DosePrice, { "app-webview": _ctx.appWebview }, null, 8, ["app-webview"])
  ], 64))
}